export default function Footer() {
  return (
    <footer className="relative w-full bg-[#e6f0ff] text-[var(--lum-cream)]/80 border-t border-[var(--lum-gold)]/15">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-12">
          <div className="md:col-span-2">
            <div className="font-jp text-3xl font-medium text-[var(--lum-cream)] mb-5 cursor-default">
              <span className="lum-wordmark">
                {"社長の放課後部".split("").map((ch, i) => (
                  <span key={i}>{ch}</span>
                ))}
              </span>
            </div>
            <p className="font-jp text-sm leading-[2.0] max-w-md text-[var(--lum-cream)]/70">
              僕がこの会で作りたいのは、人脈ではなく信頼です。
            </p>
            <div className="flex items-center gap-4 mt-8">
              {[
                { icon: "ri-instagram-line", label: "Instagram" },
                { icon: "ri-twitter-x-line", label: "X" },
                { icon: "ri-line-line", label: "LINE" },
                { icon: "ri-mail-line", label: "Email" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center border border-[var(--lum-gold)]/30 rounded-full text-[var(--lum-cream)]/60 hover:border-[var(--lum-gold)] hover:text-[var(--lum-gold)] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-[11px] text-[var(--lum-gold)] mb-5">
              <a href="/#collections-grid" className="cursor-pointer">この会について</a>
            </h4>
            <ul className="space-y-3 font-jp text-sm">
              {[
                { label: "持ち帰れるもの", href: "/#collections-grid" },
                { label: "放課後の時間割", href: "/#process" },
                { label: "よくある質問", href: "/#voices" },
                { label: "体験入部する", href: "/#booking" },
              ].map((t) => (
                <li key={t.label}>
                  <a href={t.href} className="hover:text-[var(--lum-gold)] transition-colors cursor-pointer whitespace-nowrap">
                    {t.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-[11px] text-[var(--lum-gold)] mb-5">
              お問い合わせ
            </h4>
            <ul className="space-y-3 font-jp text-sm text-[var(--lum-cream)]/70">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center text-[var(--lum-gold)] mt-1"></i>
                <span>新宿のシーシャラウンジ<br />（詳細はお申込み後にご案内）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-[var(--lum-gold)] mt-1"></i>
                <span>月に一度・20:00〜</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-wallet-line w-4 h-4 flex items-center justify-center text-[var(--lum-gold)] mt-1"></i>
                <span>体験入部 ¥9,500<br />（シーシャ代・ドリンク2杯込み）</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[var(--lum-gold)]/12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="font-label text-[11px] text-[var(--lum-cream)]/45">
            © 2026 社長の放課後部 · ALL RIGHTS RESERVED
          </span>
          <div className="flex items-center gap-6 font-label text-[11px] text-[var(--lum-cream)]/45">
            <a href="#" rel="nofollow" className="hover:text-[var(--lum-gold)] cursor-pointer whitespace-nowrap">プライバシー</a>
            <a href="#" rel="nofollow" className="hover:text-[var(--lum-gold)] cursor-pointer whitespace-nowrap">利用規約</a>
          </div>
        </div>
      </div>
    </footer>
  );
}